import script from "./GameHero.vue?vue&type=script&setup=true&lang=js"
export * from "./GameHero.vue?vue&type=script&setup=true&lang=js"

import "./GameHero.vue?vue&type=style&index=0&id=08734694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08734694"]])

export default __exports__